import {
  ONLINE_BOOKING_SECTIONS,
  type OnlineBookingTab,
} from "@/pages/stammdaten/onlineBookingSections";
import {
  subSectionsForTab,
  type OnlineBookingSubSection,
} from "@/pages/stammdaten/online-booking/onlineBookingSubSections";

interface OnlineBookingSectionIntroProps {
  tab: OnlineBookingTab;
  subSection?: OnlineBookingSubSection | null;
}

export function OnlineBookingSectionIntro({ tab, subSection }: OnlineBookingSectionIntroProps) {
  const section = ONLINE_BOOKING_SECTIONS.find((s) => s.id === tab);
  if (!section || tab === "overview") return null;

  const subSections = subSectionsForTab(tab);
  const activeSub = subSection
    ? subSections?.find((s) => s.id === subSection)
    : null;

  return (
    <div className="rounded-xl border border-separator bg-fill-quaternary px-4 py-3">
      <p className="text-sm font-medium text-label">
        {activeSub ? activeSub.label : section.label}
      </p>
      <p className="mt-1 text-sm text-label-secondary">
        {activeSub ? activeSub.description : section.description}
      </p>
    </div>
  );
}
